var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M444.422 98.206L300.424 450.189C292.939 468.469 275.189 480 256.018 480C227.178 480 208.002 456.002 208.002 432.002V272.01H48.004C25.067 272.01 5.332 255.792 0.91 233.262C-3.527 210.763 8.598 188.264 29.832 179.577L381.829 35.584C399.688 28.241 420.282 32.397 433.938 46.083C447.61 59.739 451.75 80.301 444.422 98.206Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/location-arrow.5de828e26158fa02f19c0891e2e0358c.svg";
export { ForwardRef as ReactComponent };